export var buttonGroupBehavior = function buttonGroupBehavior() {
  return {
    attributes: {
      root: {
        role: 'group'
      }
    }
  };
};